<form [formGroup]="form" class="container-fluid cvc-input-container" [ngClass]="{'container-fluid-no-padding': marginless}">
  <div class="row">
    <div class="col-sm-12">
      <!-- CVC -->
      <label class="form-label required">{{ 'CARD_FORM.SECURITY_CODE' | translate }}</label>
      <mat-form-field class="mat-form-field-fluid">
        <input
          matInput
          formControlName="cvc"
          placeholder="CVC"
          inputmode="numeric"
          data-openreplay-obscured
          (blur)="handleOnTouched()"
        />
        <mat-error *ngIf="form.get('cvc')?.hasError('required')">
          {{ 'CARD_FORM.CVC_REQUIRED' | translate }}
        </mat-error>
        <mat-error
          *ngIf="
            form.get('cvc')?.hasError('minlength') ||
            form.get('cvc')?.hasError('maxlength')
          "
        >
          {{ 'CARD_FORM.CVC_LENGTH_INVALID' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</form>

